import React, { Component } from 'react';
import { Button, Col, Input, message, Row, Table } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';

import { BackBtn } from '@comm/BackBtn';
import { querySaveFinanceBooks } from '@api/finance/finance';
// import { getAccountInfo } from "../../../../store/modules/account_info";
import util from '@util';
import { queryBudgetGroupSetList } from '@api/finance/budget';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: [],
      pageNo: 1,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.loadData();
    // this.props.dispatch(getAccountInfo());
  }

  loadData = () => {
    const params = {};
    const context = this;
    params.condition = this.state.condition || '';
    params.groupUuid = this.props.params.uuid;
    this.setState({
      isLoading: true,
    });
    queryBudgetGroupSetList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          company: res.data,
          isLoading: false,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 按条件搜索
   */
  search = () => {
    this.loadData();
  };

  /**
   * 显示添加账户弹窗
   */
  showModalAdd = () => {};

  /**
   * 显示编辑账户弹窗
   */
  showModalEdit = uuid => {
    this.uuid = uuid;
  };

  hideModal = () => {};

  /**
   * 新增账号
   */
  handAddSubmit = item => {
    querySaveFinanceBooks(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.hideModal();
        this.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 编辑账号
   */
  handEditSubmit = item => {
    item.uuid = this.uuid;
    querySaveFinanceBooks(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.hideModal();
        this.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  setCondition = e => {
    this.setState({
      condition: e.target.value,
    });
  };

  showApportion = () => {};

  columns = () => {
    return [
      {
        title: '序号',
        dataIndex: 'num',
        key: 'num',
        width: '80',
        render: (text, record, index) => {
          const tot = 15 * (this.state.pageNo - 1) + index + 1;
          return <span>{tot}</span>;
        },
      },
      {
        title: '预算组名称',
        dataIndex: 'groupName',
        key: 'groupName',
        width: '200',
      },
      {
        title: '预算余额',
        dataIndex: 'current',
        key: 'current',
        width: '200',
        render: text => {
          return <span>{util.numberFormat(text, 2, '.', ',')}</span>;
        },
      },
      {
        title: '新增预算',
        dataIndex: 'add',
        key: 'add',
        width: '200',
        render: text => {
          return <span>{util.numberFormat(text, 2, '.', ',')}</span>;
        },
      },
      {
        title: '实际支出',
        dataIndex: 'expenditureSum',
        key: 'expenditureSum',
        width: '200',
        render: text => {
          return <span>{util.numberFormat(text, 2, '.', ',')}</span>;
        },
      },
      {
        title: '实际收入',
        dataIndex: 'incomeSum',
        key: 'rest1',
        width: '200',
        render: text => {
          return <span>{util.numberFormat(text, 2, '.', ',')}</span>;
        },
      },
      {
        title: '开始时间',
        dataIndex: 'beginDate',
        key: 'beginDate',
        width: '200',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '结束时间',
        dataIndex: 'endDate',
        key: 'endDate',
        width: '200',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
    ];
  };

  render() {
    const { company, isLoading } = this.state;

    return (
      <div>
        <div className="fixed-header">
          <Row type="flex" justify="space-between">
            <Col>
              <BackBtn />
            </Col>
            <Col style={{ textAlign: 'right' }}>
              <Input
                placeholder="请输入关键字"
                style={{ width: '300px' }}
                value={this.state.condition}
                onChange={this.setCondition}
              />
              <Button type="primary" style={{ marginLeft: '10px' }} onClick={this.search}>
                搜索
              </Button>
            </Col>
          </Row>
        </div>
        <Table
          rowKey={record => record.uuid}
          rowSelection={{}}
          columns={this.columns()}
          dataSource={company}
          pagination={false}
          loading={isLoading}
          style={{ paddingTop: '46px' }}
          scroll={{ x: 1400, y: util.pageHeight() - 120 }}
        />
      </div>
    );
  }
}

export default connect(state => ({ user: state.user }))(Index);



// WEBPACK FOOTER //
// ./src/components/finance/budget/detail/Index.js